import PrimaryDashboardActions from "../actions/primaryDashboardActions";

const PrimaryDashboardReducer = (
  state = { isPrimaryDashboardLoading: false },
  action
) => {
  switch (action.type) {
    case PrimaryDashboardActions.PRIMARY_DASHBOARD_REQUEST:
      return {
        ...state,
        isPrimaryDashboardLoading: true,
        errorMessage: { isError: false },
      };
    case PrimaryDashboardActions.PRIMARY_DASHBOARD_SUCCESSFUL:
      return {
        ...state,
        isPrimaryDashboardLoading: false,
        primaryDashboard: action.data.data,
        errorMessage: { isError: false },
      };
    case PrimaryDashboardActions.PRIMARY_DASHBOARD_FAILED:
      return {
        ...state,
        isPrimaryDashboardLoading: false,
        errorMessage: { isError: true },
      };
    default:
      return {
        ...state
      };
    //   break;
  }
};

export default PrimaryDashboardReducer;
